import * as React from "react";
import { Collapse } from "./externals";
export class Accordeon extends React.Component {
    constructor(props) {
        super(props);
        this.handleClickCollapse = () => {
            if (this.state.isOpenCollapse) {
                this.setState({ isOpenCollapse: false });
            }
            else {
                this.setState({ isOpenCollapse: true });
            }
        };
        this.state = {
            isOpenCollapse: false,
        };
    }
    render() {
        const { title, children } = this.props;
        return (React.createElement("div", null,
            React.createElement("strong", null,
                React.createElement("a", { id: "title", onClick: this.handleClickCollapse }, title)),
            React.createElement(Collapse, { isOpen: this.state.isOpenCollapse }, children)));
    }
}
//# sourceMappingURL=Accordeon.js.map